/**
 * Formats an object to a pretty-printed JSON string.
 * Handles errors gracefully by falling back to String conversion.
 * @param obj - Object to format as JSON
 * @returns Pretty-printed JSON string with 2-space indentation
 */
export const formatJSON = (obj: any): string => {
  try {
    return JSON.stringify(obj, null, 2);
  } catch {
    return String(obj);
  }
};
